import {
  QueryDocumentSnapshot,
  Timestamp,
  type DocumentData,
  type SnapshotOptions
} from 'firebase/firestore'
import { FirebaseProperties } from '@/types/Helper/FirebaseProperties'

export interface EquipmentSpec {
  name: string
  value: any
}

export class Equipment extends FirebaseProperties {
  name: string = ''
  description: string = ''
  type: string = ''
  location: string = ''
  picture: string = ''
  quantity: number = 0

  specs: EquipmentSpec[] = []

  constructor(data?: any) {
    super()
    Object.assign(this, data)
  }
}

// Firestore data converter
export const EquipmentConverter = {
  toFirestore: (equipment: Equipment) => {
    equipment.firebaseInfo._updatedAt = Timestamp.now()

    return {
      name: equipment.name,
      description: equipment.description,
      type: equipment.type,
      location: equipment.location,
      picture: equipment.picture,
      quantity: equipment.quantity,
      specs: equipment.specs,

      firebaseInfo: equipment.firebaseInfo
    }
  },
  fromFirestore: (
    snapshot: QueryDocumentSnapshot<DocumentData, DocumentData>,
    options?: SnapshotOptions
  ) => {
    const data = snapshot.data(options)
    return new Equipment(data)
  }
}
